import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Label } from '@atlas/ui';

export const SkeletonTabs = () => (
  <div className="tabs-list">
    <div className="tab-list-item skeleton-bg" />
    <div className="tab-list-item skeleton-bg" />
  </div>
);

const Tabs = ({ tabs, tabIndex, setTabIndex }) => (
  <div className="tabs-list">
    {tabs.map((tabName, index) => {
      const onClick = () => {
        if (index === tabIndex) return;
        setTabIndex(index);
      };

      const className = cx(['tab-list-item', index === tabIndex && 'active']);

      return (
        <a key={tabName} className={className} onClick={onClick}>
          <Label message={tabName} />
        </a>
      );
    })}
  </div>
);

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  tabIndex: PropTypes.string.isRequired,
  setTabIndex: PropTypes.func.isRequired,
};

export default Tabs;
